export default "__VITE_ASSET__05a2013e__"